import React from 'react';

import styles from './TabTitle.module.scss';

const TabTitle: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles.title}>{children}</div>;
};

export default TabTitle;
